module.exports = __webpack_public_path__ + "img/jcb@2x.abf71595.png";